var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "currentColor", fillRule: "evenodd" },
            React.createElement("path", { d: "M29.04 34a2.24 2.24 0 012.234 2.08l.006.16H16.72A2.24 2.24 0 0118.96 34h10.08zM26.8 12c.829 0 1.552.45 1.94 1.119l7.02.001A2.24 2.24 0 0138 15.36v14.56a2.24 2.24 0 01-2.24 2.24H12.24A2.24 2.24 0 0110 29.92V15.36a2.24 2.24 0 012.24-2.24l7.02-.001A2.24 2.24 0 0121.2 12h5.6zm-7.84 3.359l-6.72.001v14.56h23.52V15.36l-6.72-.001v.001H18.96v-.001zM19.5 18v4.5H24a4.5 4.5 0 11-4.712-4.495L19.5 18zm13 7a.5.5 0 110 1h-7a.5.5 0 110-1h7zm0-3a.5.5 0 110 1h-7a.5.5 0 110-1h7zm0-3a.5.5 0 110 1h-7a.5.5 0 110-1h7z", fillRule: "nonzero" }),
            React.createElement("path", { d: "M22.32 31.04h3.36v3.36h-3.36z" }))));
});
